/**
 * @module geo/payload/facade
 */
import {ExtensionProperties, ExtensionType} from '../../types/extensions';
import {MapOptions} from '../../types/map';

/**
 *
 * @since v 2.1.0
 */
export class REGISTER_EXTENSION {
  public map?: MapOptions|null;

  type: ExtensionType;
  properties: ExtensionProperties;
  /**
   * @param options object with properties values
   */
  constructor(type: ExtensionType, properties: ExtensionProperties) {
    this.type = type;
    this.properties = properties;

    if (!properties.handle) {
      this.properties.handle = () => false;
    }
  }
}
